export default "__VITE_ASSET__CrhQrsUI__"